import { render, staticRenderFns } from "./RegistRep.vue?vue&type=template&id=75bbb1b2&scoped=true&"
import script from "./RegistRep.vue?vue&type=script&lang=js&"
export * from "./RegistRep.vue?vue&type=script&lang=js&"
import style0 from "./RegistRep.vue?vue&type=style&index=0&id=75bbb1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbb1b2",
  null
  
)

export default component.exports